import { getMethods as getMailServiceMethods } from './MailService';
import { getMethods as getGridSettingsMethods } from './GridSettings';
import { getMethods as getLicenseMethods } from './LicenseService';
import { getMethods as getAiMethods } from './AiService';

const getController = (service: 'web') => ({
	MailService: getMailServiceMethods(service, 'MailService'),
	GridSettings: getGridSettingsMethods(service, 'GridSettings'),
	License: getLicenseMethods(service, 'License'),
	Ai: getAiMethods(service, 'Ai')
});

export { getController };
